import store from "store";

@autobind
/**
 *
 */
export default class Types {
  /**
   *
   * @param {Array} items
   * @param {String} _module
   * @return {*}
   * @private
   */
  static _findModuleId(items, _module) {
    console.log("sdfsdfs_module",_module);
    
    let _item = {};
    if (items) {
      for (let i = 0; i < items.length; i++) {
        if (items[i].name === _module) {
          return items[i];
        }
        if (items[i].children && items[i].children[0]) {
          _item = Types._findModuleId(items[i].children, _module);
          if (_item && _item.id) {   
             // _item.filter((item => item.name === _module));
            return _item;
          }
        }
      }
    }
     

        console.log("findModuleId_item",_item);

    return _item;
  }

  /**
   *
   * @param {String} _module
   * @return {Object | null}
   * @private
   */
  static _findModule(_module = "") {
    let items = store.getState().General.grouped_modules;
    if (_module === "") {
      return "*";
    }
    let modules = _module.split(".");
    let item = { children: items };
    for (let i = 0; i < modules.length; i++) {
      item = Types._findModuleId(item.children, modules[i]);
    }
    console.log("findModuleId_item2",item);
    
    return item;
  }

  /**
   *
   * @param {Number} [id=0]
   * @param {Array} types
   * @return {Object | null}
   * @private
   */
  static findId(id = 0, types = store.getState().General.grouped_types) {
    let _item = types.find((item) => item.id === id);

    if (_item && _item.id) {
      return _item;
    } else {
      types.map((item) => {
        if (item.children && item.children[0] && !(_item && _item.id)) {
          _item = Types.findId(id, item.children);
        }
      });
    }

    return _item;
  }

  /**
   *
   * @param {Array} items
   * @param {Object} key
   * @param {String} label
   * @return {*}
   * @private
   */
  static _findObject(items, key, label = "") {
    let result = app._.find(items, key);
    let x;
    if (result === undefined) {
      for (x in items) {
        if (!app._.isEmpty(items[x].children)) {
          let result = Types._findObject(
            items[x].children,
            key,
            `${label} ${items[x].label}`
          );
          if (result !== undefined) {
            console.log("Sdfdfgdfgsdf",result);
            
            return result;
          }
        }
      }
      return undefined;
    } else {
      return `${label} ${result.label}`;
    }
  }

  /**
   *
   * @param {Object} key
   * @param {String} label
   * @return {*}
   */
  static findObject(key, label = "") {
    const types = store.getState().General.grouped_types;
    return Types._findObject(types, key, label);
  }

  /**
   *
   * @param {String} [_module='']
   * @param {Boolean} [withChildren=true]
   * @param {Boolean} [check=(item)=> true]
   * @param {Boolean} [grouped=true]
   * @return {Array}
   */
  static items(
    _module = "",
    withChildren = true,
    check = () => true,
    grouped = true
  ) {
    
    let types;
    if (grouped) types = store.getState().General.grouped_types;
    else types = store.getState().types;
    let _return = [];
    let _findModule = Types._findModule(_module);
    console.log("types", types);
    if (_findModule) {
      types?.map((item) => {      
        if ((!app.haveUiPermission(["shiftRequest"]) &&  (item.id === 258 || item.id === 259||item.id === 373 || item.id === 374))) {
         
          return;
      }
      if(item.id===171 && item.forModuleId!==3){
          return
         }
        if (
          (_findModule === "*" || item.forModuleId === _findModule.id) &&
          check(item)
        ) {
          _return.push(
            Object.assign(
              {},
              {
                id: item.id,
                name: item.name,
                label: item.label,
                value: item.id,
                rule: item.rule,
                form: item.form,
                typeId: item.typeId,
                moduleId: item.moduleId,
                forModuleId: item.forModuleId,
                isPrivate: item.rule && item.rule.id ? item.rule.isPrivate : 0,
              },
              withChildren ? { children: item.children } : {}
            )
          );
        }
      });
    }

    return _return;
  }
}
